// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 461 ? "3596f54e" : chunkId) + "." + {"454":"5339dee82e010f12","461":"f4e6dbce1ac15ef4"}[chunkId] + ".js";
};